var _desc, _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecentHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 46,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 34.6144 -34.6144 0 496.1429 504.5584)",
    id: 921747
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "Rounded_Rectangle_726"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(254,69,110)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -13,
    y: -11,
    rx: 8,
    ry: 8,
    width: 26,
    height: 22
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.5 0)",
    id: "arrow"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAAe0lEQVQokZ3RwQnCQBCF4cWTp9ysxRJSRGzJs70I1iDBSjwFD/GTxUSGNcTEgVnmsfszM/sSKjzQIOsLWuwG/cl8bHFHPwBH77iVwFjsA3DAaQqIbX4CqZhrFigfl0AdgHaT5kO4ff49xuIFF3/dKlOy3V2w+4zrl92kFzBJnf506xaTAAAAAElFTkSuQmCC",
    x: -5.5,
    y: -6,
    width: 11,
    height: 12
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentHide);
export default __webpack_public_path__ + "static/media/recent-hide.9a7fe8c3.svg";
export { ForwardRef as ReactComponent };